import React, { useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    access_key: "3c434427-a8a6-471d-8eab-a27971c4afaa", // Replace with your Web3Forms access key
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        setFormSubmitted(true);
        setFormData({ name: "", email: "", message: "", access_key: "YOUR_ACCESS_KEY" });
      } else {
        setError("Failed to send message. Please try again.");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: "2rem auto", padding: "1rem" }}>
      <Typography variant="h4" gutterBottom>
        Contact Us
      </Typography>
      <Typography variant="body1" gutterBottom>
        Have a question or need assistance? Fill out the form below and we’ll get back to you as soon as possible.
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Your Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Your Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Your Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          multiline
          rows={4}
          fullWidth
          margin="normal"
          required
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ marginTop: "1rem" }}
          fullWidth
        >
          Submit
        </Button>
      </form>
      {formSubmitted && (
        <Typography
          variant="body1"
          sx={{ marginTop: "1rem", color: "green", textAlign: "center" }}
        >
          Thank you! Your message has been sent successfully.
        </Typography>
      )}
      {error && (
        <Typography
          variant="body1"
          sx={{ marginTop: "1rem", color: "red", textAlign: "center" }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default ContactUsPage;
